// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MobileFilledSvg from "@ant-design/icons-svg/es/asn/MobileFilled";
import AntdIcon from '../components/AntdIcon';

var MobileFilled = function MobileFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MobileFilledSvg
  }));
};

MobileFilled.displayName = 'MobileFilled';
export default React.forwardRef(MobileFilled);